import { type CSSProperties } from 'typestyle/lib/types';
import { type Styles } from 'react-modal';
import { calc } from 'csx';
import StyleConstants from '../../../core/styles.constants';

export const modalStyle = (isMobile?: boolean): Styles => ({
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: '1px 2px 15px rgba(0, 0, 0, 0.25)',
    borderRadius: 8,
    width: isMobile ? '95%' : '80%',
    maxWidth: isMobile ? calc('100% - 20px') : '900px',
    maxHeight: '90vh',
    padding: 30,
    overflow: 'auto',
    backgroundColor: StyleConstants.WHITE_COLOR,
  },
});

export const columnHeader: CSSProperties = {
  wordBreak: 'break-word',
  fontSize: StyleConstants.HEADER_FONT_SIZE,
  fontWeight: StyleConstants.HEADER_FONT_WEIGHT,
  fontFamily: StyleConstants.HEADER_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  padding: '8px 0',
};

export const sectionHeader: CSSProperties = {
  wordBreak: 'break-word',
  fontSize: StyleConstants.CARD_TITLE_FONT_SIZE,
  fontWeight: StyleConstants.CARD_TITLE_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  padding: '8px 0',
  textTransform: 'uppercase',
};

export const labelText: CSSProperties = {
  fontSize: StyleConstants.SECONDARY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
};

export const selectInput: CSSProperties = {
  width: '100%',
  padding: '8px 12px',
  borderRadius: 4,
  border: `1px solid ${StyleConstants.LIGHT_GREY_COLOR}`,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  fontSize: StyleConstants.SECONDARY_FONT_SIZE,
  color: StyleConstants.GREY_COLOR,
  backgroundColor: StyleConstants.WHITE_COLOR,
  outline: 'none',
};

export const storeyButton = (isActive: boolean): CSSProperties => ({
  padding: '6px 16px',
  borderRadius: 4,
  border: `1px solid ${isActive ? StyleConstants.DARK_BLUE_COLOR : StyleConstants.LIGHT_GREY_COLOR}`,
  backgroundColor: isActive ? StyleConstants.DARK_BLUE_COLOR : StyleConstants.WHITE_COLOR,
  color: isActive ? StyleConstants.WHITE_COLOR : StyleConstants.GREY_COLOR,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  fontSize: StyleConstants.TERTIARY_FONT_SIZE,
  fontWeight: StyleConstants.PRIMARY_FONT_WEIGHT,
  cursor: 'pointer',
  transition: 'all 0.2s ease',
});

export const dayPartButton = (isActive: boolean): CSSProperties => ({
  padding: '6px 20px',
  borderRadius: 4,
  border: `1px solid ${isActive ? StyleConstants.ORANGE_COLOR : StyleConstants.LIGHT_GREY_COLOR}`,
  backgroundColor: isActive ? StyleConstants.ORANGE_COLOR : StyleConstants.WHITE_COLOR,
  color: isActive ? StyleConstants.WHITE_COLOR : StyleConstants.GREY_COLOR,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  fontSize: StyleConstants.TERTIARY_FONT_SIZE,
  fontWeight: StyleConstants.PRIMARY_FONT_WEIGHT,
  cursor: 'pointer',
  transition: 'all 0.2s ease',
});

export const selectedWorkplaceText: CSSProperties = {
  fontSize: StyleConstants.PRIMARY_FONT_SIZE,
  fontWeight: StyleConstants.PRIMARY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.MEDIUM_BLUE_COLOR,
  padding: '4px 0',
};

export const infoText: CSSProperties = {
  fontSize: StyleConstants.TERTIARY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.LIGHT_GREY_COLOR,
  fontStyle: 'italic',
};

export const buttonRow: CSSProperties = {
  display: 'flex',
  gap: 12,
  marginTop: 16,
};

export const floorPlanContainer: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  padding: '8px 0',
};
